import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { dropsFilesUrl } from "../Globals";
import { useNavigate } from "react-router-dom";
import { CommandContextStore } from "../context/CommandContext";
const yaml = require("js-yaml");

export const SearchBar = () => {
  const [searchItems, setSearchItems] = useState([]);
  const [toolsWithSections, setToolsWithSections] = useState([]);
  const [finalResults, setFinalResults] = useState([]);
  const commandContext = React.useContext(CommandContextStore);
  const navigate = useNavigate();

  // Combine the children tool of each Tactic
  function combineSubItems(data) {
    const combinedArrays = [];
    data.forEach((obj) => {
      if (obj.items && Array.isArray(obj.items)) {
        combinedArrays.push(...obj.items);
      }
    });
    return combinedArrays;
  }

  // Get files.json
  const commandsFileNavigation = `${dropsFilesUrl}/commands/files.json`;
  const getAllFiles = async function () {
    console.log("GETTING FILES");
    await fetch(commandsFileNavigation)
      .then((resp) => resp.json())
      .then((data) => {
        const combinedItems = combineSubItems(data);
        setSearchItems(combinedItems);
      });
  };

  const fetchToolYaml = async function (tool) {
    try {
        const toolYamlPath = `${dropsFilesUrl}/${tool.id}`;
        const resp = await fetch(toolYamlPath);
        const data = await resp.text();
        const jsonyaml = yaml.safeLoad(data);
        const newTool = {
            ...tool,
            sections: jsonyaml.sections
        };      
        return newTool;
    } catch (error) {
        console.error('Error fetching tool YAML:', error);
        return null;
    }
    
  };


// Search tools names and their tags (Case-insensitive)
    const handleSearch = (event, inputValue) => {
        var sectionedDropDownResults = [];
        const lowerInputValue = inputValue.toLowerCase();
        const results = searchItems.filter((obj) => {
        const lowerLabel = obj.label.toLowerCase();
        const labelMatch = lowerLabel.includes(lowerInputValue);
        const tagMatch = obj.tags.some((tag) =>
            tag.toLowerCase().startsWith(lowerInputValue)
        );        
        return labelMatch || tagMatch;
        });
        
        if (results.length > 0 && inputValue.length > 3) {
            const resultsToFetch = results.filter((obj) => {
              // Check if obj.id is not in toolsWithSections
              return !toolsWithSections.some((tool) => tool.id === obj.id);
            });
            
            //console.log("RESULTS TO FETCH", resultsToFetch);
            //console.log("YAMLS in CACHE:", toolsWithSections.length)
            const sectionsToolPromises = resultsToFetch.map((obj) => {
                console.log("FETCHING", obj.id);
                return fetchToolYaml(obj).then((sectionsTool) => sectionsTool);
              });
          
              Promise.all(sectionsToolPromises)
                .then((fetchedSectionsTools) => {
                  setToolsWithSections([...toolsWithSections, ...fetchedSectionsTools]);
                })
                .catch((error) => {
                  console.error("Error fetching sections: ", error);
                });           

                sectionedDropDownResults = toolsWithSections.flatMap((tool) => {
                    if (tool.sections) {
                      let sectionIndex = -1; // Initialize the section index                  
                      const sectionMatchObject = tool.sections.map((section) => {
                        // Increment the section index for each section
                        sectionIndex++;
                        if (section.name.toLowerCase().includes(lowerInputValue)) {
                          return {
                            label: `${tool.label} - ${section.name}`,
                            path: tool.label,
                            id: tool.id,
                            section_index: sectionIndex
                          };
                        }
                        return null;
                      });                  
                      return sectionMatchObject.filter((section) => section !== null);
                    }
                    return [];
                  });                                   
        }
    
        
          var dropDownResults = results.map((result) => ({
            label: result.label,
            path: result.label,
            id: result.id
          }));
          const concatenatedResults = [...dropDownResults, ...sectionedDropDownResults];
          setFinalResults(concatenatedResults);
        }
                 
  

  // Navigate to tool's section on selection
  const handleToolSelect = (selectedTool) => {
    const toolPath = selectedTool?.path ?? false;
    const toolSectionIndex = selectedTool?.section_index === 0 ? 0 : selectedTool?.section_index || false;
    if (toolPath) {
      let uri = `/?tool=${toolPath}`
      if (toolSectionIndex === 0 || toolSectionIndex) {
        uri = `${uri}#command${toolSectionIndex}`
      }
      console.log("Navigating to: ", uri);
      commandContext.dispatch({ type: "UPDATE_SRC", data: selectedTool.id });
      navigate(uri);
    } else {
      console.error("TOOL Doesn't exist");
    }
  };

  // Get files.json on mount
  React.useEffect(() => {
    getAllFiles();
  }, []);

  return (
    <Autocomplete
      id="search-bar"
      size="small"
      style={{ backgroundColor: "white" }}
      fullWidth
      clearOnEscape
      options={finalResults}
      getOptionLabel={(option) => option.label}
      filterOptions={(options, params) => options}
      onInputChange={handleSearch}
      onChange={(_, value) => handleToolSelect(value)}
      renderInput={(params) => (
        <TextField
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          {...params}
          autoFocus
          placeholder="Search Tool or Tag"
        />
      )}
    />
  );
};
